$('.js-input').each(function() {
	if($(this).val()) {
		$(this).addClass('notEmpty');
	} else {
		$(this).removeClass('notEmpty');
	}
});

$('.js-input').on('input', function() { 
   if($(this).val()) {
		$(this).addClass('notEmpty');
	} else {
		$(this).removeClass('notEmpty');
	}
});

$('#voorwaarden').mouseenter(function(){
	$('.voorwaarden__container').addClass('open');
});

$('#voorwaarden').mouseleave(function(){
	$('.voorwaarden__container').removeClass('open');
});


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/inputValue.js